// Doing a different workout than the calendar says (Kenny, 2026-10-22: "I actually did Leg Day
// on Tuesday instead of Thursday"). Pure date logic, no DB. Weeks run Monday to Sunday.

const parse = (iso) => { const [y, m, d] = iso.split('-').map(Number); return new Date(y, m - 1, d); };
const fmt = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;

export function mondayOf(iso) {
  const dt = parse(iso);
  const back = (dt.getDay() + 6) % 7; // Mon=0 .. Sun=6
  dt.setDate(dt.getDate() - back);
  return fmt(dt);
}

export function sameWeek(a, b) { return mondayOf(a) === mondayOf(b); }

// The session (if any) where this workout day was already done in the same week as iso.
export function doneThisWeek(sessions, dayId, iso) {
  return (sessions || []).find((s) => s.program_day_id === dayId && s.date && sameWeek(s.date, iso)) || null;
}

// Which workout to offer on a date: the scheduled one, unless it is already done this week,
// then the first lift day (in week order) not done yet this week.
export function suggestDay(liftDays, sessions, iso, scheduledId) {
  if (scheduledId && !doneThisWeek(sessions, scheduledId, iso)) return scheduledId;
  const open = [...(liftDays || [])].sort((a, b) => (a.weekday || 9) - (b.weekday || 9)).find((d) => !doneThisWeek(sessions, d.id, iso));
  return open?.id || scheduledId || liftDays?.[0]?.id || null;
}

// A workout can't be done in the future: starting from a future date logs it today.
export function startDateFor(pickedISO, todayISO) { return pickedISO > todayISO ? todayISO : pickedISO; }
